var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 8.00111C15.5 11.867 12.3648 15 8.49889 15C4.63301 15 1.5 11.867 1.5 8.00111C1.5 4.13301 4.63301 1 8.49889 1C12.3648 1 15.5 4.13301 15.5 8.00111Z",
    fill: "#585D66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78 9.84V9.78C8.78 9.37 8.97 9.06 9.32 8.81L9.73 8.52C10.32 8.1 10.72 7.54 10.72 6.75C10.72 5.74 9.91 4.76 8.36 4.76C6.88 4.76 6.07 5.8 6.07 6.88C6.07 7.03 6.08 7.19 6.12 7.33L7.38 7.38C7.35 7.29 7.34 7.18 7.34 7.06C7.34 6.5 7.65 5.93 8.36 5.93C9.03 5.93 9.36 6.37 9.36 6.83C9.36 7.13 9.23 7.4 8.93 7.62L8.45 7.98C7.88 8.41 7.66 8.9 7.66 9.43C7.66 9.58 7.68 9.71 7.7 9.84H8.78ZM7.47 11.29C7.47 11.73 7.82 12.08 8.26 12.08C8.7 12.08 9.06 11.73 9.06 11.29C9.06 10.85 8.7 10.49 8.26 10.49C7.82 10.49 7.47 10.85 7.47 11.29Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMarkIcon);
export default __webpack_public_path__ + "static/media/question-mark-icon.1662af60cf3c0f9462b0b573093999c9.svg";
export { ForwardRef as ReactComponent };